import { useCallback } from 'react';
import { ToastAlert, useToast } from '@frameio/vapor';

const DEFAULT_DURATION = 4000;

type ToastOptions = {
  title: string;
  canDismiss?: boolean;
  duration?: number;
};

/**
 * @returns a callback function for showing an error toast
 */
export function useErrorToast() {
  const { addToast } = useToast();

  /**
   * Adds an error ToastAlert to the toast stack.
   *
   * @param title The title of the error toast
   * @param canDismiss Whether the toast should be dismissable
   * @param duration The duration before the toast is automatically dismissed, defaults to 4s
   * @returns void
   */
  return useCallback(
    ({ title, canDismiss, duration }: ToastOptions) => {
      addToast(
        (closeToast, toastCloseLabel) =>
          canDismiss ? (
            <ToastAlert title={title} variant="error" />
          ) : (
            <ToastAlert
              closeLabel={toastCloseLabel}
              onRequestClose={closeToast}
              title={title}
              variant="error"
            />
          ),
        {
          duration: duration ?? DEFAULT_DURATION,
        }
      );
    },
    [addToast]
  );
}
